import classNames from "classnames";
import styles from "./AscDraggableImageCard.module.scss";
import { useDrag } from "react-dnd";
import { QuizDraggableActivityItem } from "@ascendnow/shared";
import AscImage from "../../../AscImage/AscImage";

export interface AscDraggableImageCardProps {
  className?: string;
  id: string;
  imageUrl: string;
  disabled?: boolean;
  onDrag: (itemId: string, containerId: string) => void;
}

export default function AscDraggableImageCard({
  className,
  id,
  imageUrl,
  onDrag,
  disabled = false,
}: AscDraggableImageCardProps) {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: QuizDraggableActivityItem,
      item: { id },
      end: (item, monitor) => {
        const dropResult = monitor.getDropResult<Record<"id", string>>();
        if (item && dropResult) {
          onDrag(item.id, dropResult.id);
        }
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
        handlerId: monitor.getHandlerId(),
      }),
    }),
    [onDrag]
  );
  return (
    <div
      data-testid="asc-draggable-image-card"
      ref={disabled ? null : drag}
      className={classNames(
        styles.ground,
        {
          [styles.isDragging]: isDragging,
          [styles.disabled]: disabled,
        },
        className
      )}
    >
      <AscImage className={styles.image} src={imageUrl} />
    </div>
  );
}
